import { detectBrowserLanguage } from '#src/lib/detectBrowserLanguage.ts';
import {
  ALLOWED_LOCALES,
  DEFAULT_LOCALE,
  type AvailableLanguage,
} from '#src/lib/i18n.ts';
import { localStorage } from '#src/lib/storage/localStorage.ts';

export const getAllowedLocales = (locale: string | null) => {
  if (locale?.startsWith('en')) {
    return DEFAULT_LOCALE;
  }
  return ALLOWED_LOCALES.includes(locale || '')
    ? (locale as AvailableLanguage)
    : null;
};

export const getSafeLocaleFromUrl = (pathname: string) => {
  const localeFromUrl = pathname.split('/')[1] ?? '';
  const safeLocaleFromUrl = getAllowedLocales(localeFromUrl);
  const safePreferredLocale = getAllowedLocales(
    localStorage.getStringItem('preferredLocale') ?? null
  );
  const safeBrowserLocale = getAllowedLocales(detectBrowserLanguage());
  return (
    safeLocaleFromUrl ||
    safePreferredLocale ||
    safeBrowserLocale ||
    DEFAULT_LOCALE
  );
};
